export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-4021775.4d6df3f9.jpg";